import { render, staticRenderFns } from "./OrdersCompleted.vue?vue&type=template&id=798fb679"
import script from "./OrdersCompleted.vue?vue&type=script&lang=js"
export * from "./OrdersCompleted.vue?vue&type=script&lang=js"
import style0 from "./OrdersCompleted.vue?vue&type=style&index=0&id=798fb679&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports